export enum PageType {
  Math = 'MATH',
  Ela = 'ELA',
  Demo = 'DEMO',
  Aggregator = 'AGGREGATOR',
}